// cronBuilder Component
// Friendly editor for a single Quartz cron expression stored in a hidden <input x-ref="output">.
// Modes: DISABLED (empty value), DAILY, WEEKLY, MONTHLY and ADVANCED (raw cron escape hatch).
// Quartz uses 6 fields: second minute hour day-of-month month day-of-week.
//   DAILY    -> 0 m h * * ?
//   WEEKLY   -> 0 m h ? * MON,WED,FRI
//   MONTHLY  -> 0 m h <dom> * ?
// On init the existing value is parsed back into the controls; anything we cannot recognise
// falls back to ADVANCED so the raw expression is preserved and still editable.
const WEEKDAYS = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

const pad = (n) => String(n).padStart(2, '0');

export default () => ({
    freq: 'DISABLED',
    hour: 6,
    minute: 0,
    time: '06:00',
    dom: 1,
    raw: '',
    cron: '',
    weekdays: { MON: false, TUE: false, WED: false, THU: false, FRI: false, SAT: false, SUN: false },

    init() {
        this.output = this.$refs.output;
        this.parse(this.output ? this.output.value : '');
        this.build();
    },

    toggle(code) {
        this.weekdays[code] = !this.weekdays[code];
        this.build();
    },

    onTime() {
        const parts = (this.time || '').split(':');
        this.hour = parseInt(parts[0], 10) || 0;
        this.minute = parseInt(parts[1], 10) || 0;
        this.build();
    },

    build() {
        const m = this.minute;
        const h = this.hour;
        let c = '';
        if (this.freq === 'DAILY') {
            c = `0 ${m} ${h} * * ?`;
        } else if (this.freq === 'WEEKLY') {
            const days = WEEKDAYS.filter((d) => this.weekdays[d]);
            c = days.length ? `0 ${m} ${h} ? * ${days.join(',')}` : '';
        } else if (this.freq === 'MONTHLY') {
            c = `0 ${m} ${h} ${this.dom} * ?`;
        } else if (this.freq === 'ADVANCED') {
            c = (this.raw || '').trim();
        }
        this.cron = c;
        if (this.output) this.output.value = c;
    },

    parse(value) {
        const v = (value || '').trim();
        if (!v) {
            this.freq = 'DISABLED';
            return;
        }
        const t = v.split(/\s+/);
        if (t.length === 6 && t[0] === '0') {
            const minute = t[1];
            const hour = t[2];
            const dom = t[3];
            const month = t[4];
            const dow = t[5];
            this.minute = parseInt(minute, 10) || 0;
            this.hour = parseInt(hour, 10) || 0;
            this.time = `${pad(this.hour)}:${pad(this.minute)}`;

            if (dom === '*' && month === '*' && dow === '?') {
                this.freq = 'DAILY';
                return;
            }
            if (dom === '?' && month === '*' && /^[A-Z]{3}(,[A-Z]{3})*$/.test(dow)) {
                this.freq = 'WEEKLY';
                dow.split(',').forEach((d) => {
                    if (d in this.weekdays) this.weekdays[d] = true;
                });
                return;
            }
            if (month === '*' && dow === '?' && /^\d+$/.test(dom)) {
                this.freq = 'MONTHLY';
                this.dom = parseInt(dom, 10) || 1;
                return;
            }
        }
        this.freq = 'ADVANCED';
        this.raw = v;
    }
});
